import type { Template } from "@/types";

export const LA_02_H1_V1: Template[] = [
    {
        id: "la-02-h1v1-01",
        name: "LA 01 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 39, y: 71, width: 599, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 881, y: 71, width: 266, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v1-02",
        name: "LA 02 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 71, y: 99, width: 533, height: 335, rotation: 0, imageRotation: 0 },
            { id: "2", x: 851, y: 38, width: 327, height: 457, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v1-03",
        name: "LA 03 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 30, y: 33, width: 616, height: 466, rotation: 0, imageRotation: 0 },
            { id: "2", x: 985, y: 33, width: 333, height: 466, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v1-04",
        name: "LA 04 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 717, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 868, y: 0, width: 393, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v1-05",
        name: "LA 05 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 188, y: 47, width: 300, height: 438, rotation: 0, imageRotation: 0 },
            { id: "2", x: 714, y: 47, width: 599, height: 438, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v1-06",
        name: "LA 06 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 188, y: 47, width: 300, height: 438, rotation: 0, imageRotation: 0 },
            { id: "2", x: 677, y: 0, width: 676, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v1-07",
        name: "LA 07 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 183, y: 57, width: 324, height: 417, rotation: 0, imageRotation: 0 },
            { id: "2", x: 515, y: 57, width: 655, height: 417, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v1-08",
        name: "LA 08 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 785, y: 99, width: 459, height: 335, rotation: 0, imageRotation: 0 },
            { id: "2", x: 221, y: 99, width: 235, height: 335, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v1-09",
        name: "LA 09 - H1V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 34, y: 33, width: 320, height: 466, rotation: 0, imageRotation: 0 },
            { id: "2", x: 706, y: 33, width: 616, height: 466, rotation: 0, imageRotation: 0 }
        ],
    }
];